import React from "react";
import "../../assets/css/vendor.bundle.css";
import "../../assets/css/style.css";
import "../../assets/css/theme.css";
import TrendingViewChart from "../tradingview_chart/TradingViewChart";
import MediumWidget from "../medium_widget/MediumWidget";
import ForexCrossRatesWidget from "../forexcrossrates_widget/ForexCrossRatesWidget";
import Navbar from "../common/NavBar";
import Footer from "../common/Footer";
import { Helmet } from "react-helmet-async";

const Shares = () => {
    return (
        <div>
            <Helmet>
                <title>Shares</title>
            </Helmet>
            <div className="site-header header-s1 is-sticky">
                <Navbar />
                {/* Banner/Slider */}
                <div className="page-head section row-vm light has-bg-image">
                    <div className="imagebg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/page-inside-bg.jpg')})` }}>
                        <img
                            src={require("../../assets/images/page-inside-bg.jpg")}
                            alt="page-head"
                        />
                    </div>
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-md-12">
                                <h2>Shares</h2>
                                <div className="page-breadcrumb">
                                    <ul className="breadcrumb">
                                        <li>
                                            <a href="/">Markets</a>
                                        </li>
                                        <li className="active">
                                            <span>Shares</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* #end Banner/Slider */}
            </div>
            {/*Section */}
            <div className="section section-pad bg-grey">
                <div className="container">
                    <h2>
                        With AFC Trades, you can trade Share CFDs
                    </h2>
                    <div class="gaps size-3x"></div>
                    <div className="row row-vm forex-p">
                        <div className="col-md-5">
                            <div className="round mgr--30 res-m-bttm">
                                <img
                                    src={require("../../assets/images/post-thumb-a.jpg")}
                                    alt="photo-md"
                                    className="img-shadow"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-md-offset-1">
                            <div className="text-block text-left">
                                <h4>What are the advantages of trading forex?</h4>
                                <p>
                                    AFC Trades has one of the best CFD trading platforms in the world, with over 10,000 United Kingdom and worldwide
                                    share CFDs, as well as stock CFDs and indices, spread over four continents.
                                    <br />
                                    <br />
                                    You may profit from price swings in any direction by trading stock CFDs on the world's most prominent
                                    firms along with share CFDs across worldwide markets.
                                    <br />
                                    <br />
                                    At AFC Trades, you may trade Stock CFDs and Share CFDs on two sophisticated platforms, on desktop and
                                    mobile, from the same trading account (Apple iOS & Android). The stock CFDs are available in a variety
                                    of worldwide marketplaces, notably London, Hong Kong, Paris, Frankfurt, Madrid, Amsterdam, and New York
                                    (NYSE & Nasdaq), and encompass a broad variety of industries such as healthcare, aviation, tourism, and
                                    Big Tech. AFC Trades is blazing a trail yet again with an advanced set of stock CFDs that will provide
                                    traders with limitless and exceptional prospects in global markets.
                                </p>

                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>
            {/*Section */}

            {/*Section */}
            <div className="section section-pad">
                <div className="container">
                    <h2>
                        Our AFC Trades trading platform allows you to trade share CFDs.
                    </h2>
                    <div class="gaps size-3x"></div>
                    <div className="row row-vm forex-p">

                        <div className="col-md-6">
                            <div className="text-block text-left">
                                <p>
                                    The most prominent Forex trading platform in the industry AFC Trades platform. Although it is best known for
                                    trading forex and commodities, it also offers a variety of share CFDs. AFC Trades provides access to 54 Share CFDs traded on
                                    four different international exchanges, as well as a variety of account types. With leverage options up to 30:1, you may
                                    go long or short on some of the world's greatest companies.Although it is best known for trading forex and commodities,
                                    it also offers a variety of share CFDs. AFC Trades provides access to 54 Share CFDs traded on four different international exchanges,
                                    as well as a variety of account types.
                                    With leverage options up to 30:1, you may go long or short on some of the world's greatest companies.
                                </p>

                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>
                        <div className="col-md-5  col-md-offset-1">
                            <div className="round mgr--30 res-m-bttm">
                                <img
                                    src={require("../../assets/images/service-thumb-dd.jpg")}
                                    alt="photo-md"
                                    className="img-shadow"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            {/*Section */}
            <div className="section section-pad bg-grey">
                <div className="container">
                    <h2>
                        With AFC Trades, you can trade Share CFDs
                    </h2>
                    <div class="gaps size-3x"></div>
                    <div className="row row-vm forex-p">
                        <div className="col-md-5">
                            <div className="round mgr--30 res-m-bttm">
                                <img
                                    src={require("../../assets/images/service-thumb-bb.jpg")}
                                    alt="photo-md"
                                    className="img-shadow"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-md-offset-1">
                            <div className="text-block text-left">
                                <h4>What's the Difference Between CFD and Stock Trading?</h4>
                                <p>
                                    The main distinction between CFD trading and stock trading is that investors do not own the underlying asset,
                                    which is a physical share. As previously established, CFD refers to contract for difference, and you never truly
                                    own the asset or item you are trading when you trade a CFD, but you can still profit if the share market moves in
                                    your advantage or lose money if the market goes in the opposite direction.
                                    <br />
                                    <br />
                                    CFDs are a leveraged commodity, and the margin requirements imply that you'd need to deposit a fraction of the whole
                                    valuation of the trade to create a CFD position, while shares are typically acquired for the entire value owed in
                                    share trading.
                                    <br />
                                    <br />
                                    Since leverage entails a risk of suspential loss, it is critical to understand the risks associated with leverage
                                    before investing.
                                </p>

                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>
            {/*Section */}
            <Footer />
        </div>
    );
};

export default Shares;
